import { render, staticRenderFns } from "./TabVIews.vue?vue&type=template&id=07d60753&scoped=true&"
import script from "./TabVIews.vue?vue&type=script&lang=js&"
export * from "./TabVIews.vue?vue&type=script&lang=js&"
import style0 from "./TabVIews.vue?vue&type=style&index=0&id=07d60753&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d60753",
  null
  
)

export default component.exports